import type { SVGProps } from 'react';
const actionResetTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={20} viewBox="0 0 20 20" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 9.65482 2.15482 9.375 2.5 9.375C2.84518 9.375 3.125 9.65482 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C7.63956 3.125 5.49071 4.32444 4.23665 6.24982L6.875 6.25C7.19552 6.25 7.45969 6.49128 7.4958 6.80211L7.5 6.875C7.5 7.19552 7.25872 7.45969 6.94789 7.4958L6.875 7.5H3.125C2.80448 7.5 2.54031 7.25872 2.5042 6.94789L2.5 6.875V3.125C2.5 2.77982 2.77982 2.5 3.125 2.5C3.44552 2.5 3.70969 2.74128 3.7458 3.05211L3.75 3.125L3.74974 4.80731C5.26688 2.98137 7.53627 1.875 10 1.875Z"
      fill={props.color ?? '#D32336'}
      fillRule="evenodd"
    />
  </svg>
);
export default actionResetTemplateOutline;
